export enum ToastPositions {
    TOP_LEFT = "top-left",
    TOP_RIGHT = "top-right",
    TOP_CENTER = "top-center",
    BOTTOM_LEFT = "bottom-left",
    BOTTOM_RIGHT = "bottom-right",
    BOTTOM_CENTER = "bottom-center"
}

// Default position
export const DEFAULT_POSITION: ToastPositions = ToastPositions.BOTTOM_RIGHT;

// Default time to for toast to close (in ms)
export const DEFAULT_DELAY = 4000;

// Default hideProgressBar flag
export const DEFAULT_HIDE_PROGRESS_FLAG = false;

// Default closeOnClick flag
export const DEFAULT_CLOSE_ON_CLICK_FLAG = true;

// Default pauseOnHover flag
export const DEFAULT_PAUSE_ON_HOVER_FLAG = true;

// Default draggable flag
export const DEFAULT_DRAGGABLE_FLAG = true;
